import { COMPONENT_KINDS } from '../../types/SimpleSupplyPoint';

/**
 * Component varsayılan şablonları
 * Her component tipi için standart ayarlar
 */
export const COMPONENT_TEMPLATES = {

  // ===============================
  // SUPPLY BOX (Ana Beslenme)
  // ===============================
  [COMPONENT_KINDS.SUPPLY]: {
    electrical: {
      voltage: 380,
      phaseCount: 3,
      installedPower: 0,
      demandPower: 0,
      current: 0,
      demandFactor: "60-40%",
      purposeOfUse: "Mesken",
      subscribeType: "Mesken"
    },
    incomingFeeders: [], // Supply'ın incoming feeder'ı olmaz
    outgoingFeeders: [],
    outs: [], // Load eklenirken dolar
    entries: [], // Giriş noktaları
    metadata: {
      type: 'supply',
      subtype: 'main_supply',
      standards: 'IEC',
      region: 'Turkey'
    }
  },

  // ===============================
  // METER PANEL (Ana Pano)
  // ===============================
  [COMPONENT_KINDS.METER_PANEL]: {
    electrical: {
      voltage: 380,
      phaseCount: 3,
      installedPower: 0,
      demandPower: 0,
      current: 0,
      demandFactor: "60-40%",
      purposeOfUse: "Mesken",
      subscribeType: "Mesken"
    },
    incomingFeeders: [],
    outgoingFeeders: [],
    outs: [], // Load eklenirken dolar
    entries: [], // ComponentFactory tarafından dinamik olarak doldurulacak
    metadata: {
      type: 'meter_panel',
      subtype: 'adp', // Ana Dağıtım Panosu
      standards: 'IEC',
      region: 'Turkey',
      panelType: 'enclosed', // Kapalı tip
      ipRating: 'IP40'
    }
  },

  // ===============================
  // DISTRIBUTION PANEL (Dağıtım Panosu)
  // ===============================
  [COMPONENT_KINDS.DIST_PANEL]: {
    electrical: {
      voltage: 380,
      phaseCount: 3,
      installedPower: 0,
      demandPower: 0,
      current: 0,
      demandFactor: "60-40%",
      purposeOfUse: "Mesken",
      subscribeType: "Mesken"
    },
    incomingFeeders: [],
    outgoingFeeders: [],
    outs: [], // Load eklenirken dolar
    entries: [], // ComponentFactory tarafından dinamik olarak doldurulacak
    metadata: {
      type: 'dist_panel',
      subtype: 'distribution',
      standards: 'IEC',
      region: 'Turkey',
      panelType: 'surface_mounted',
      ipRating: 'IP20'
    }
  },

  // ===============================
  // PANEL (Genel Panel)
  // ===============================
  [COMPONENT_KINDS.PANEL]: {
    electrical: {
      voltage: 220,
      phaseCount: 1,
      installedPower: 0,
      demandPower: 0,
      current: 0,
      demandFactor: "60-40%",
      purposeOfUse: "Mesken",
      subscribeType: "Mesken"
    },
    incomingFeeders: [],
    outgoingFeeders: [],
    outs: [], // Load eklenirken dolar
    entries: [], // ComponentFactory tarafından dinamik olarak doldurulacak
    metadata: {
      type: 'panel',
      subtype: 'standard',
      standards: 'IEC',
      region: 'Turkey'
    }
  },

  // ===============================
  // LOAD (Yük)
  // ===============================
  [COMPONENT_KINDS.LOAD]: {
    electrical: {
      voltage: 220,
      phaseCount: 1,
      installedPower: 0,
      demandPower: 0,
      current: 0,
      powerFactor: 0.9
    },
    incomingFeeders: [],
    outgoingFeeders: [], // Load'lar genelde terminal
    outs: [], // Load'ların out'u olmaz
    entries: [], // Load'ların entry'si olmaz
    metadata: {
      type: 'load',
      loadType: 'machine', // machine, socket, lighting
      standards: 'IEC',
      region: 'Turkey'
    }
  },

  // ===============================
  // BRANCH (Dal Devresi)
  // ===============================
  [COMPONENT_KINDS.BRANCH]: {
    electrical: {
      voltage: 220,
      phaseCount: 1,
      installedPower: 0,
      demandPower: 0,
      current: 0,
      powerFactor: 0.9
    },
    incomingFeeders: [],
    outgoingFeeders: [],
    outs: [],
    entries: [],
    metadata: {
      type: 'branch',
      branchType: 'socket', // socket, lighting
      standards: 'IEC',
      region: 'Turkey'
    }
  },

  // ===============================
  // SOCKET (Priz)
  // ===============================
  [COMPONENT_KINDS.SOCKET]: {
    electrical: {
      voltage: 220,
      phaseCount: 1,
      installedPower: 0,
      demandPower: 0,
      current: 0,
      powerFactor: 0.9
    },
    incomingFeeders: [],
    outgoingFeeders: [],
    outs: [],
    entries: [],
    metadata: {
      type: 'socket',
      socketType: 'standard', // standard, usb, network
      standards: 'IEC',
      region: 'Turkey'
    }
  }
};

/**
 * Component tipi için varsayılan şablonu döndürür
 */
export function getComponentTemplate(kind) {
  const template = COMPONENT_TEMPLATES[kind];
  if (!template) {
    return null;
  }

  // Deep copy to prevent mutation
  return JSON.parse(JSON.stringify(template));
}

/**
 * Mevcut component'leri template ile karşılaştır ve eksik alanları tamamla
 */
export function validateAndCompleteComponent(component) {
  const template = getComponentTemplate(component.kind);
  if (!template) return component;

  return {
    ...template,
    ...component,
    electrical: {
      ...template.electrical,
      ...component.electrical
    },
    metadata: {
      ...template.metadata,
      ...component.metadata
    }
  };
}